import React from 'react'
import { compose } from 'recompose'
import {
  bool,
  string,
  object,
  func,
} from 'prop-types'
import toArray from 'lodash/toArray'
import isNil from 'lodash/isNil'
import {
  List,
  ListItem,
  Divider,
  FontIcon,
  Subheader,
} from 'material-ui'
import muiThemeable from 'material-ui/styles/muiThemeable'
import NavigationTheme from 'cmsThemes/mui/Navigation'


const Navigator = compose(
  muiThemeable(),
)(
  ({
    collapse,
    navigationData,
    checkActive,
    muiTheme: {
      CustomSideBar,
    },
    onClick,
  }) => {
    const generateMenu = (menus) => {
      if (isNil(menus)) return []
      return toArray(menus).map((menu, i) => (
        <div key={`${menu.name}-${i}`}>
          <ListItem
            style={{
              ...NavigationTheme.menuListItemStyle,
              color: checkActive(menu.value) ?
                CustomSideBar.active.color : CustomSideBar.inactive.color,
              borderLeft: checkActive(menu.value) ? ` 3px solid ${CustomSideBar.active.color}` : '0px',
            }}
            innerDivStyle={
              Object.assign(
                CustomSideBar.font,
                {
                  ...NavigationTheme.menuListInnerDivStyle,
                  paddingBottom: collapse ? 34 : 18,
                },
              )
            }
            primaryText={collapse ? '' : menu.name}
            leftIcon={
              <FontIcon
                style={{
                  ...NavigationTheme.iconStyle,
                  color: checkActive(menu.value) ?
                    CustomSideBar.active.color : CustomSideBar.inactive.color,
                }}
                className={menu.icon}
              />
            }
            nestedItems={generateMenu(menu.children)}
            onTouchTap={() => onClick( menu.path)}
          />
          <Divider />
        </div>
      ))
    }

    return (
      <List style={NavigationTheme.listStyle}>
        {generateMenu(navigationData)}
      </List>
    )
  },
)

Navigator.propTypes = {
  navigationData: object.isRequired,
  collapse: bool,
  onClick: func,
  checkActive: func,
}

Navigator.defaultProps = {
  collapse: false,
  onClick: () => {},
  checkActive: () => {},
}

export default Navigator



// WEBPACK FOOTER //
// ./src/components/Navigator/Navigation.js